import React, { useState, useEffect } from 'react';

const ScrollToggleButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [scrollDirection, setScrollDirection] = useState('down');

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.pageYOffset;
      // Hauteur totale défilable (on soustrait la taille de la fenêtre)
      const scrollableHeight = document.body.scrollHeight - window.innerHeight;

      // On choisit un seuil (par ex. 100px) pour afficher le bouton
      setIsVisible(scrollY > 100);

      // On se base sur la moitié de la zone défilable
      if (scrollableHeight > 0) {
        // Dans la première moitié de la page => flèche vers le bas
        if (scrollY < scrollableHeight / 2) {
          setScrollDirection('down');
        } 
        // Dans la seconde moitié => flèche vers le haut
        else {
          setScrollDirection('up');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Au clic, on descend si flèche vers le bas, on remonte si flèche vers le haut
  const handleClick = () => {
    if (scrollDirection === 'down') {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // Style du bouton (pour la démo, inline)
  const buttonStyle = {
    display: isVisible ? 'inline-block' : 'none',
    backgroundColor: isHovered ? '#00FFFF' : '#FF33CC',
    width: '50px',
    height: '50px',
    textAlign: 'center',
    borderRadius: '25px',
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    transition: 'all 0.3s',
    zIndex: 1000,
    border: 'none',
    outline: 'none',
    color: 'white',
    fontSize: '20px',
    padding: '10px',
    cursor: 'pointer',
    marginBottom: '50px',
  };

  // Ici on inverse la rotation : si on est en "down", on pivote l’icône à 180°
  // (alors qu’avant, "down" signifiait rotation 0)
  const iconStyle = {
    transition: 'transform 0.3s',
    transform: scrollDirection === 'down' ? 'rotate(180deg)' : 'rotate(0deg)',
  };

  return (
    <button
      onClick={handleClick}
      style={buttonStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <i className="fas fa-arrow-up" style={iconStyle}></i>
    </button>
  );
};

export default ScrollToggleButton;





// import React, { useState, useEffect } from 'react';

// const BackToTopButton = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [isActive, setIsActive] = useState(false); // Nouvel état pour "active"

//   const toggleVisibility = () => {
//     setIsVisible(window.pageYOffset > 300);
//   };

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth',
//     });
//   };

//   useEffect(() => {
//     window.addEventListener('scroll', toggleVisibility);
//     return () => window.removeEventListener('scroll', toggleVisibility);
//   }, []);

//   const baseStyle = {
//     display: isVisible ? 'inline-block' : 'none',
//     backgroundColor: '#FF33CC',
//     width: '50px',
//     height: '50px',
//     textAlign: 'center',
//     borderRadius: '25px',
//     position: 'fixed',
//     bottom: '30px',
//     right: '30px',
//     transition: 'background-color .3s',
//     zIndex: '1000',
//     border: 'none',
//     outline: 'none',
//     color: 'white',
//     fontSize: '20px',
//     padding: '10px',
//     cursor: 'pointer',
//     marginBottom: '50px',
//   };

//   const hoverStyle = {
//     backgroundColor: '#00FFFF',
//   };

//   const activeStyle = {
//     backgroundColor: '#D90093',
//   };

//   let buttonStyle = {...baseStyle};
//   if (isHovered) buttonStyle = {...buttonStyle, ...hoverStyle};
//   if (isActive) buttonStyle = {...buttonStyle, ...activeStyle};

//   return (
//     <button
//       onClick={scrollToTop}
//       style={buttonStyle}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//       onMouseDown={() => setIsActive(true)} // Appliquer le style "active" lors de l'enfoncement
//       onMouseUp={() => setIsActive(false)}   // Retirer le style "active" lors du relâchement
//     >
//       <i className="fas fa-arrow-up"></i>
//     </button>
//   );
// };

// export default BackToTopButton;


